import R from 'app/assets/R'
import {
  FunctionPermissionEnum,
  ModulePermissionEnum,
} from 'app/common/permission-module'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { SectionBase } from 'app/components/common/SectionBase'
import { useTable } from './hook'
import { FilterLayout } from './layouts'
import { BaseTableReport, HeadPageWrapper, RootWrapper } from './styles'

export const Report021Container = () => {
  const {
    filter,
    handleChangeFilter,
    data,
    columns,
    isLoading,
    handleTableChange,
    pagination,
    handleExportExcel,
    totalItem,
  } = useTable()
  const { isHavePermissionFunction } = useVerifyPermissionAndRedirect()
  return (
    <RootWrapper>
      <HeadPageWrapper
        titleI18nKey={R.strings.report_21}
        isExport={isHavePermissionFunction(
          ModulePermissionEnum.REPORT,
          FunctionPermissionEnum.REPORT_EXPORT_REPORT_21,
        )}
        onPressExport={handleExportExcel}
      />
      <SectionBase>
        <BaseSpace>
          <FilterLayout
            totalItem={totalItem}
            formData={filter}
            onChange={handleChangeFilter}
          />

          <BaseTableReport
            columns={columns}
            dataSource={data}
            pagination={pagination}
            loading={isLoading}
            onChange={handleTableChange}
            rowClassName="row-overwrite-style"
            scroll={{
              x: true,
            }}
          />
        </BaseSpace>
      </SectionBase>
    </RootWrapper>
  )
}
